/**
 * Versions of the player (specs 012, 020).
 */

declare const __RUNTIME_VERSION__: string | undefined;

/** The `version` of Shared/package.json, set by the build; `0.0.0-dev` when run unbuilt (tests). */
export const RUNTIME_VERSION: string =
  typeof __RUNTIME_VERSION__ === 'string' ? __RUNTIME_VERSION__ : '0.0.0-dev';

/**
 * The newest manifest `formatVersion` this player plays (spec 020). 1 is the
 * raw shape (absent = 1), 2 has playable scenes and `runtimeVersion`.
 */
export const SUPPORTED_FORMAT_VERSION = 2;

/** What story publish writes into `manifest.formatVersion`. */
export const MANIFEST_FORMAT_VERSION = 2;
